const annualBillingList = [
  'até R$1.000,00',
  'até R$10.000,00',
  'até R$100.000,00',
  'até R$500.000,00',
  'até R$999.000,00',
  'mais de R$1.000.000,00',
];

export default annualBillingList;